var _path, _circle, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLensSmartBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24609 20.8016V1.5H29.6747C34.2461 1.5 34.754 4.03968 34.754 7.59524V20.2937M2.24609 20.8016V26.3889C2.24609 28.7593 3.26197 33.5 7.32546 33.5H29.6747C31.3678 33.3307 34.754 31.6714 34.754 26.3889V20.2937M2.24609 20.8016C3.93922 19.9551 7.8334 18.5667 9.86514 19.7858C11.389 20.971 15.1477 22.5286 17.9921 19.2778C21.717 15.045 30.2842 9.32228 34.754 20.2937",
    stroke: "#5627D9",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.6607,
    cy: 7.08741,
    r: 2.03175,
    fill: "#5627D9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.84803,
    cy: 7.5951,
    rx: 1.52381,
    ry: 1.52381,
    fill: "#5627D9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4382,
    cy: 14.198,
    rx: 3.04762,
    ry: 3.04762,
    fill: "#5627D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLensSmartBack);
export default __webpack_public_path__ + "static/media/lens-smart-back.93ef9634e8f73e37d2fb273fd3b196be.svg";
export { ForwardRef as ReactComponent };